import { render, staticRenderFns } from "./ParcelaView.vue?vue&type=template&id=48de190a&scoped=true&"
import script from "./ParcelaView.vue?vue&type=script&lang=js&"
export * from "./ParcelaView.vue?vue&type=script&lang=js&"
import style0 from "./ParcelaView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ParcelaView.vue?vue&type=style&index=1&id=48de190a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de190a",
  null
  
)

export default component.exports